import React from "react";

import { Button, Col, FormLabel, Row } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { BaseBean, RestReportBean } from "../ds/client_ds.js";
import {
  FabricStyleInventoryAdjustmentSearchCriteria,
  FabricStyleSearchCriteria,
  FabricStyleSKUBean,
  PageListBean,
  PurchaseOrderReceiptSearchCriteria,
  PurchaseOrderSearchCriteria,
  RestFabricStyleInventoryAdjustmentListRequest,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestPurchaseOrderListRequest,
  RestPurchaseOrderReceiptListRequest,
  RestReadRequest,
  RestSkuBatchInventoryListRequest,
  SkuBatchInventoryPageListPrintRequest,
  SKUBatchInventoryPrintInputBean,
  SKUBatchInventoryPrintInputCriteria,
  SKUBatchInventorySearchCriteria,
} from "../ds/ds.js";
import {
  AlertToolBox,
  DataGridColumnDefinition,
  EditableDataGrid,
  InputTextbox,
  ProgressBar,
  ShowError,
  ColumnDefinition,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import CustomTable from "../gui_components/CustomTable.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { InventoryAdjustmentLookupHandler } from "../lookup/InventoryAdjustmentLookupHandler.js";
import { PurchaseOrderLookupHandler } from "../lookup/PurchaseOrderLookupHandler.js";
import { PurchaseOrderReceiptLookupHandler } from "../lookup/PurchaseOrderReceiptLookupHandler.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { InventoryService } from "../services/InventoryService.js";
import { PurchaseOrderReceiptService } from "../services/PurchaseOrderReceiptService.js";
import { PurchaseOrderService } from "../services/PurchaseOrderService.js";
import { ReportService } from "../services/ReportService.js";
import { BaseInquiryToolBar } from "./BaseModule.js";
import { ModuleUtils } from "./ModuleUtils.js";
class PrintRollForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Print Roll",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: false,
      isShowExitButton: true,
      isShowResetButton: false,
      error_list: [],
      inquiryDataList: [],
      selectedRollSkuList: [],
      criteria: new SKUBatchInventorySearchCriteria(),
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMessage: [],
      alertType: "",
      alertMsg: "",
      success_list: [],
      isShowFabricStyleModule: false,
      moduleForPopup: [],
      roll_criteria: new SKUBatchInventoryPrintInputCriteria(),
      colorLookupHandler: null,
      isShowColorLookup: false,
      colorList: new Array(),
      locationList: null,
      locations: [],
      locationData: null,
      isShowLookup: true,
      isDisabledFields: false,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: true,
      showAutoCompleteFabricColorList: true,
      locationPageListForAutoCompleteList: new Array(),
      showAutoCompleteLocationList: true,
      isShowAutoCompletePurchaseOrderList: false,
      purchaseOrderPageListForAutoCompleteList: new Array(),
      purchaseReceiptPageListForAutoCompleteList: new Array(),
      showAutoCompletepurchaseReceiptList: false,
      isShowAutoCompleteAdjustmentList: false,
      adjustmentPageListForAutoCompleteList: new Array(),
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      is3PL: false,
      currentPage:1,
      totalPage:0,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    const attribute_cache = { ...this.cache };

    const locations = new Array();
    if (!isEmptyArray(attribute_cache.warehouses))
      locations.push(...attribute_cache.warehouses);
    this.state.locations = ModuleUtils.isActiveAttribute(locations);

    this.initLookupHandlers();
    let roll_criteria = this.state.roll_criteria;
    roll_criteria.noOfCopies = 1;
    this.setState({
      roll_criteria: roll_criteria,
    });
  }
  initLookupHandlers = () => {
    let purchaseOrderLookupHandler = new PurchaseOrderLookupHandler(
      this.companyCode,
      "Purchase Order",
    );
    this.setState({ purchaseOrderLookupHandler: purchaseOrderLookupHandler });

    let purchaseReceiptLookupHandler = new PurchaseOrderReceiptLookupHandler(
      this.companyCode,
      "Purchase Receipt",
    );
    this.setState({
      purchaseReceiptLookupHandler: purchaseReceiptLookupHandler,
    });

    let inventoryAdjustmentLookupHandler = new InventoryAdjustmentLookupHandler(
      this.companyCode,
      "Inventory Adjustment",
    );
    this.setState({
      inventoryAdjustmentLookupHandler: inventoryAdjustmentLookupHandler,
    });

    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style",
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });

    let warehouseLookupHandler = new GenericAttributeLookupHandler(
      this.state.locations,
      "Warehouse",
    );
    this.setState({ warehouseLookupHandler: warehouseLookupHandler });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisabledFields: true,
    });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        ),
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  rollOnChange = (e) => {
    let roll_criteria = this.state.roll_criteria;
    roll_criteria["noOfCopies"] = e.target.value;
    this.setState({ roll_criteria: roll_criteria });
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteFabricList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
        isShowColorLookup: false,
        colorList: [],
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let criteria = this.state.criteria;
    this.setState({ isFabricStyleDataLoding: false });
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        let colors = fabricStyle.colors;
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color",
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            isShowColorLookup: true,
            criteria: criteria,
            colorList: finalColorList,
            fabricStyleData: fabricStyle,
            isShowProgressBarPopup: false,
            progressLoadingText: "",
          });
        }
      }
    }
  };
  readandsetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    this.setState({ isFabricStyleDataLoding: true });
    FabricStyleService.readFabricStyle(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.errorCallBack,
    );
  };
  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.errorCallBack,
    );
  }
  readByFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
    });
    this.readandsetFabricStyleDetail(fabricStyleCode);
    this.setState({
      fabricPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteList });
  };
  onFabricColourCodeChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let colorCode = e.target.value;
    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmpty(colorCode)) {
      this.state.showAutoCompleteFabricColorList = false;
      let showAutoCompleteFabricColorList =
        this.state.showAutoCompleteFabricColorList;
      let criteria = this.state.criteria;
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "colorCode" &&
      showAutoCompleteFabricColorList === true &&
      colorCode !== ""
    ) {
      this.readFabricColourBySearchString(e.target.value);
    }
  };
  readFabricColourBySearchString(searchString) {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.fabricStyleColorCode == searchString
        )
          skuBean = sku;
      });
    }
    criteria.colorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    let fabricStyleColourCode = e.target.value;
    this.fabricStyleColorSelected(fabricStyleColourCode);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricColorList: showAutoCompleteList });
  };
  fabricStyleColorSelected = (colorCode) => {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.fabricStyleColorCode == colorCode
        )
          skuBean = sku;
      });
    }
    criteria.colorCode = colorCode;
    this.setState({ criteria: criteria });
  };
  onLocationChange = (e) => {
    let locationCode = e.target.value;
    this.state.showAutoCompleteLocationList = true;
    let criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteLocationList;
    if (isEmpty(locationCode)) {
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      let criteria = this.state.criteria;
      criteria.locationCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteLocationList: showAutoCompleteList,
        criteria: criteria,
        locationPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && locationCode !== "") {
      this.readLocationBySearchString(locationCode);
    }
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  readLocation = (locationCode) => {
    let locationBean = null;
    let locationData = null;
    this.state.locations.map((ln) => {
      if (ln.code === locationCode) {
        locationBean = ln;
        locationData = new BaseBean();
        locationData.code = ln.code;
        locationData.description = ln.description;
      }
    });
    if (!isEmpty(locationBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.locationCode = locationBean.code;
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompleteList: showAutoCompleteList,
      });
    }
    this.setState({ locationList: locationBean, locationData: locationData });
  };
  readLocationBySearchString(searchString) {
    let locationData = this.state.locations;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((locations) => {
        let simpleItemBean = {
          code: locations.code,
          description: locations.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ locationPageListForAutoCompleteList: filteredSuggestions });
  }
  locationEnterKeyEventHandler = (e) => {
    let locationCode = e.target.value;
    this.readLocation(locationCode);
    this.setState({
      locationPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteLocationList = (showAutoCompleteLocationList) => {
    this.setState({
      showAutoCompleteLocationList: showAutoCompleteLocationList,
    });
  };
  onPurchaseOrderChange = (e) => {
    let purchaseOrderNumber = e.target.value;
    this.state.isShowAutoCompletePurchaseOrderList = true;
    let criteria = this.state.criteria;
    let showAutoCompleteList = this.state.isShowAutoCompletePurchaseOrderList;
    if (isEmpty(purchaseOrderNumber)) {
      this.state.isShowAutoCompletePurchaseOrderList = false;
      let showAutoCompleteList = this.state.isShowAutoCompletePurchaseOrderList;
      let criteria = this.state.criteria;
      criteria.purchaseOrderNumber = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        purchaseOrderPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "purchaseOrderNumber" &&
      showAutoCompleteList === true &&
      purchaseOrderNumber !== ""
    ) {
      this.readPurchaseOrderBySearchString(e.target.value);
    }
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  readPurchaseOrderBySearchString(searchString) {
    let searchCriteria = new PurchaseOrderSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.purchaseOrderNumberStartsWith = searchString;
    searchCriteria.purchaseOrderNumberContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestPurchaseOrderListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    PurchaseOrderService.getPurchaseOrderPageList(
      cust_requestInput,
      this.readPurchaseOrderBySearchStringResponse,
      this.errorCallBack,
    );
  }
  readPurchaseOrderBySearchStringResponse = (response) => {
    let purchaseorderData = response.data.purchaseOrderPageList.purchaseOrders;
    let simpleAutoCompleteList = new Array();
    if (response.data.purchaseOrderPageList != null) {
      if (purchaseorderData.length > 0 && purchaseorderData != null) {
        purchaseorderData.map((po) => {
          let simpleItemBean = {
            code: po.code,
            description: "",
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
    }
    this.setState({
      purchaseOrderPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  purchaseOrderEnterKeyEventHandler = (e) => {
    let poCode = e.target.value;
    this.readPurchaseOrder(poCode);
    this.setState({
      purchaseOrderPageListForAutoCompleteList: new Array(),
    });
  };
  readPurchaseOrder = (purchaseOrderCode) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Reading PurchaseOrder ..",
    });
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = purchaseOrderCode;
    PurchaseOrderService.initPurchaseOrderModule(
      readrestInput,
      this.readPurchaseOrderResponse,
      this.errorCallBack,
    );
  };
  readPurchaseOrderResponse = (response) => {
    if (response.data != null && response.data.purchaseOrderResponse != null) {
      if (!isEmptyArray(response.data.purchaseOrderResponse.purchaseOrder)) {
        let poBean = response.data.purchaseOrderResponse.purchaseOrder;
        let criteria = this.state.criteria;
        criteria.purchaseOrderNumber = poBean.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  displayAutoCompletePurchaseOrderList = (showAutoCompleteList) => {
    this.setState({
      isShowAutoCompletePurchaseOrderList: showAutoCompleteList,
    });
  };
  onPurchaseReceiptChange = (e) => {
    let purchaseReceitpNumber = e.target.value;
    this.state.showAutoCompletepurchaseReceiptList = true;
    let criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompletepurchaseReceiptList;
    if (isEmpty(purchaseReceitpNumber)) {
      this.state.showAutoCompletepurchaseReceiptList = false;
      let showAutoCompleteList = this.state.showAutoCompletepurchaseReceiptList;
      let criteria = this.state.criteria;
      criteria.purchaseReceitpNumber = "";
      let suggestion = [];
      this.setState({
        showAutoCompletepurchaseReceiptList: showAutoCompleteList,
        criteria: criteria,
        purchaseReceiptPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "purchaseReceitpNumber" &&
      showAutoCompleteList === true &&
      purchaseReceitpNumber !== ""
    ) {
      this.readpurchaseReceiptBySearchString(e.target.value);
    }
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  readpurchaseReceiptBySearchString(searchString) {
    let receiptCriteria = new PurchaseOrderReceiptSearchCriteria();
    receiptCriteria.companyCode = this.companyCode;
    receiptCriteria.purchaseOrderReceiptNumberStartsWith = searchString;
    let requestInput = new RestPurchaseOrderReceiptListRequest();
    requestInput.pageInput = new RestPageListBean();
    requestInput.searchCriteria = receiptCriteria;
    PurchaseOrderReceiptService.getPurchaseOrderReceiptPageList(
      requestInput,
      this.loadByPurchaseOrderReceiptResponse,
      this.errorCallBack,
    );
  }
  loadByPurchaseOrderReceiptResponse = (response) => {
    let receiptList =
      response.data.purchaseOrderReceiptPageList.purchaseOrderReceipts;
    let simpleAutoCompleteList = new Array();
    if (receiptList.length > 0 && receiptList != null) {
      receiptList.map((receipt) => {
        let simpleItemBean = {
          code: receipt.code,
          description: "",
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      purchaseReceiptPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  purchaseReceiptEnterKeyEventHandler = (e) => {
    this.readAndSetRollLines(e.target.value, e.target.name);
    this.setState({ purchaseReceiptPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompletepurchaseReceiptList = (
    showAutoCompletepurchaseReceiptList,
  ) => {
    this.setState({
      showAutoCompletepurchaseReceiptList: showAutoCompletepurchaseReceiptList,
    });
  };
  adjustmentOnChange = (e) => {
    let inventoryAdjustmentNumber = e.target.value;
    this.state.isShowAutoCompleteAdjustmentList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.isShowAutoCompleteAdjustmentList;
    if (isEmpty(inventoryAdjustmentNumber)) {
      this.state.isShowAutoCompleteAdjustmentList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteAdjustmentList;
      let criteria = this.state.criteria;
      criteria.inventoryAdjustmentNumber = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteAdjustmentList: showAutoCompleteList,
        criteria: criteria,
        adjustmentPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "inventoryAdjustmentNumber" &&
      showAutoCompleteList === true &&
      inventoryAdjustmentNumber !== ""
    ) {
      this.readAdjustmentBySearchString(e.target.value);
    }
    tempCriteria["inventoryAdjustmentNumber"] = e.target.value;
    this.setState({ adjustmentCriteria: tempCriteria });
  };
  adjustmentEnterKeyEventHandler = (e) => {
    let criteria = this.state.criteria;
    criteria.inventoryAdjustmentNumber = e.target.value;
    this.setState({
      adjustmentPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteAdjustmentList: false,
      criteria: criteria,
    });
  };
  readAdjustmentBySearchString = (inventoryAdjustmentNumber) => {
    let readrestInput = new RestFabricStyleInventoryAdjustmentListRequest();
    let pageList = new RestPageListBean();
    let criteria = new FabricStyleInventoryAdjustmentSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.adjustmentCodeStartsWith = inventoryAdjustmentNumber;
    readrestInput.searchCriteria = criteria;
    readrestInput.pageInput = pageList;
    InventoryService.getFabricStyleInventoryAdjustmentPageList(
      readrestInput,
      this.readInventoryAdjustmentResponse,
      this.errorCallBack,
    );
  };
  readInventoryAdjustmentResponse = (response) => {
    if (response.data.fabricStyleInventoryAdjustmentPageList != null) {
      if (
        response.data.fabricStyleInventoryAdjustmentPageList
          .fabricStyleInventoryAdjustments != null
      ) {
        let adJustmentData =
          response.data.fabricStyleInventoryAdjustmentPageList
            .fabricStyleInventoryAdjustments;
        let simpleAutoCompleteList = new Array();
        if (adJustmentData.length > 0 && adJustmentData != null) {
          adJustmentData.map((obj) => {
            let simpleItemBean = {
              code: obj.code,
              description: "",
            };
            simpleAutoCompleteList.push(simpleItemBean);
          });
        }
        this.setState({
          adjustmentPageListForAutoCompleteList: simpleAutoCompleteList,
        });
      }
    }
  };
  displayAutoCompleteAdjustmentList = (isShowAutoCompleteAdjustmentList) => {
    this.setState({
      isShowAutoCompleteAdjustmentList: isShowAutoCompleteAdjustmentList,
    });
  };
  readAndSetRollLines = (code) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "reading...",
    });
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = code;
    PurchaseOrderReceiptService.readPurchaseOrderReceipt(
      readrestInput,
      this.readSelectedReceiptResponse,
      this.errorCallBack,
    );
  };
  readSelectedReceiptResponse = (response) => {
    if (response.data != null && response.data.purchaseOrderReceipt != null) {
      let receiptData = response.data.purchaseOrderReceipt;
      let criteria = this.state.criteria;
      criteria.purchaseReceitpNumber = receiptData.code;
      this.setState({
        criteria: criteria,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  // readAndSetRollLines = (code, name) => {
  //   this.setState({
  //     isShowProgressBarPopup: true,
  //     progressLoadingText: "reading...",
  //   });
  //   let readrestInput = new RestSkuBatchInventoryListRequest();
  //   let pageInput = new PageListBean();
  //   let criteria = this.state.criteria;
  //   criteria.companyCode = this.companyCode;
  //   if (name === "purchaseReceitpNumber") {
  //     criteria.purchaseReceitpNumber = code;
  //   }
  //   readrestInput.searchCriteria = criteria;
  //   readrestInput.pageInput = pageInput;
  //   InventoryService.getSkuBatchInventoryPageList(
  //     readrestInput,
  //     this.readSelectedReceiptResponse,
  //     this.errorCallBack
  //   );
  // };
  // readSelectedReceiptResponse = (response) => {
  //   if (
  //     response.data != null &&
  //     response.data.skuBatchInventoryPageList != null
  //   ) {
  //     if (
  //       !isEmptyArray(
  //         response.data.skuBatchInventoryPageList.skuBatchInventories
  //       )
  //     ) {
  //       let rollLines =
  //         response.data.skuBatchInventoryPageList.skuBatchInventories;
  //       let criteria = this.state.criteria;
  //       rollLines.map((line) => {
  //         criteria.purchaseReceitpNumber = line.purchaseOrderReceiptNumber;
  //       });
  //       this.setState({
  //         criteria: criteria,
  //       });
  //     }
  //   }
  //   this.setState({
  //     isShowProgressBarPopup: false,
  //     progressLoadingText: "",
  //   });
  // };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  loadPage = () => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 20;
    pageInput.currentPage = this.state.currentPage;
    let listRequest = new RestSkuBatchInventoryListRequest();
    listRequest.searchCriteria = criteria;
    listRequest.pageInput = pageInput;
    if (
      !isEmptyString(criteria.fabricStyleCode) ||
      !isEmptyString(criteria.purchaseOrderNumber) ||
      !isEmptyString(criteria.purchaseReceitpNumber) ||
      !isEmptyString(criteria.inventoryAdjustmentNumber)
    ) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Executing ...",
      });

      
      this.loadRollSkuInquiryList(listRequest);
    } else {
      let errMsg = "";
      if (!this.state.is3PL) {
        errMsg =
          "PO# or PO Receipt# or Adjustment# or Fabric Style is required!";
      } else {
        errMsg = "PO# or PO Receipt# or Adjustment# or Item is required!";
      }
      let errList = [];
      errList.push(errMsg);
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadRollSkuInquiryList = (listRequest) => {
    if (SecurityAccessManager.PrintRollBarCodeMaintenance_IsAccessible()) {
      InventoryService.getSkuBatchInventoryPageListWithHoldingInventory(
        listRequest,
        this.loadRollSkuInquiryPageResponse,
        this.errorCallBack,
      );
    } else {
      this.inValidAccess(1);
    }
  };
    calculateTotalPages = (totalCount, pageSize) => {
    if (!totalCount || !pageSize) {
      return 0;
    } else {
      return Math.ceil(totalCount / pageSize);
    }
  };

  loadRollSkuInquiryPageResponse = (response) => {
    this.showErrorMessage(response.data);
     let totalPage = this.state.totalPage;
    if (
      response.data != null &&
      response.data.skuBatchInventoryPageList != null
    ) {
      let resultList = new Array();
      if (
        !isEmptyArray(
          response.data.skuBatchInventoryPageList.skuBatchInventories,
        )
      ) {
        resultList =
          response.data.skuBatchInventoryPageList.skuBatchInventories;
           totalPage = this.calculateTotalPages(
          response.data.skuBatchInventoryPageList.totalCount,
         20,
        );
      }
      this.setState({
        inquiryDataList: resultList,
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        isShowLookup: false,
        isShowColorLookup: false,
        selectedRollSkuList: [],
        totalPage:totalPage,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  errorCallBack = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error: " + error);
  };
  lineSelectAll = (e) => {
    if (e.detail == 1) {
      let list = this.state.inquiryDataList;
      list.map((line) => {
        line.isActive = true;
      });
      this.setState({ selectedRollSkuList: list });
    }
  };
  lineUnSelectAll = (e) => {
    if (e.detail == 1) {
      let list = this.state.inquiryDataList;
      list.map((line) => {
        line.isActive = false;
      });
      this.setState({ selectedRollSkuList: [] });
    }
  };
  colorLotList = (e) => {
    if (e.detail == 1) {
      let inquiryDataList = this.state.inquiryDataList;
      let dataList = [];
      inquiryDataList
        .sort((a, b) =>
          a.fabricStyleColorCode.localeCompare(b.fabricStyleColorCode),
        )
        .map((list) => {
          dataList.push(list);
        });
      dataList.sort((a, b) => a.vendorBatchNumber - b.vendorBatchNumber);
      this.setState({ inquiryDataList: dataList });
    }
  };
  generatePDF = (e) => {
    if (e.detail == 1) this.generateMultiPrint(1);
  };
  generateMultiPrint = (reportType) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating ...",
    });
    let selectedRollSkuList = this.state.selectedRollSkuList;
    let rollSkuList = [];
    for (let list of selectedRollSkuList) {
      let inputBean = new SKUBatchInventoryPrintInputBean();
      inputBean.rollSkuNumber = list.rollSkuNumber;
      inputBean.locationCode = list.locationCode;
      rollSkuList.push(inputBean);
    }
    let roll_criteria = new SKUBatchInventoryPrintInputCriteria();
    roll_criteria.companyCode = this.companyCode;
    roll_criteria.rollSkuList = rollSkuList;
    roll_criteria.noOfCopies = this.state.roll_criteria.noOfCopies;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 20;
    pageInput.currentPage = 1;
    let listRequest = new SkuBatchInventoryPageListPrintRequest();
    listRequest.criteria = roll_criteria;
    listRequest.reportBean = reportBean;
    listRequest.pageInput = pageInput;
    if (!isEmptyArray(rollSkuList)) {
      if (
        SecurityAccessManager.PrintRollBarCodeMaintenancePDFReport_IsAccessible()
      ) {
        ReportService.generateMultiRollSkuEntityPrintReport(
          listRequest,
          this.generateMultiPrintResponse,
          this.errorCallBack,
        );
      } else {
        this.inValidAccess(2);
      }
    } else {
      let errMsg = "Select the Line";
      let error_list = [];
      error_list.push(errMsg);
      this.setState({
        alertMessage: error_list,
        alertType: "danger",
        isShowAlert: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  generateMultiPrintResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    // this.loadPage();
    this.setState({
      // selectedRollSkuList: [],
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  rollLineCheck = (e,rowData) => {
    let selectedLine = this.state.selectedRollSkuList;
    if (rowData.isActive === true) {
      selectedLine.push(rowData);
      this.setState({ selectedRollSkuList: selectedLine });
    } else {
      let selectedRollSkuList = this.state.selectedRollSkuList;
      let rollList = [];
      for (let roll of selectedRollSkuList) {
        if (roll.isActive != rowData.isActive) {
          rollList.push(roll);
          this.setState({ selectedRollSkuList: rollList });
        } else if (selectedRollSkuList.length == 1) {
          this.setState({ selectedRollSkuList: [] });
        }
      }
    }
  };

    rollLineCheck = (e, rowData) => {
    const selectedRollSkuList = [...this.state.selectedRollSkuList];

    if (e.target.value) {
      rowData.isActive = true;
      selectedRollSkuList.push(rowData);
    } else {
      rowData.isActive = false;

      const index = selectedRollSkuList.findIndex(
        (item) => item.SKUNumber === rowData.SKUNumber && item.rollSkuNumber === rowData.rollSkuNumber,
      );

      if (index > -1) {
        selectedRollSkuList.splice(index, 1);
      }
    }

    this.setState({ selectedRollSkuList });
  };


  columnDefinitions = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("", "isActive", false)
        .setInputDetails(false, false, true, null, this.rollLineCheck, null)
        .setStyleDetails("", "", "", "wt-1-5 ", "wt-1-5 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Inventory#" : "RollSKU#",
          "rollSkuNumber",
          true,
        )
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("PurchaseNumber", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PurchaseReceipt#", "purchaseOrderReceiptNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ReceiptDate", "receivedDate", true, false, true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("VendorLot#", "vendorBatchNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Roll#", "rollNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );

    if (this.state.is3PL) {
      columns.push(
        new ColumnDefinition()
          .setDetails("Item", "fabricStyleCode", true)
          .setStyleDetails("left", "", "", "wt-2", "wt-2"),
      );
    } else {
      columns.push(
        new ColumnDefinition()
          .setDetails("FabricStyle", "fabricStyleCode", true)
          .setStyleDetails("left", "", "", "wt-2", "wt-2"),
      );
    }
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails(
    //       this.state.is3PL ? "LO#" : "PO#",
    //       "purchasOrderNumber",
    //       true,
    //     )
    //     .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    // );
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails(
    //       this.state.is3PL ? "LR#" : "PR#",
    //       "purchaseOrderReceiptNumber",
    //       true,
    //     )
    //     .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    // );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "fabricStyleName", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("WidthCode", "widthCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("RcvdQty", "receivedQuantity", true, true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQty#", "onHandQuantity", true, true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );

    return columns;
  };

  columnDefinitions_Bkup = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          "",
          "isActive",
          0,
          false, //set hyperlink false
          null, //set hyperLink call back null
          false,
          null,
        )
        .setEditableDetails(
          false,
          "",
          null,
          false,
          null,
          true,
          this.rollLineCheck,
        ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        this.state.is3PL ? "Inventory#" : "RollSKU#",
        "rollSkuNumber",
        1,
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "PurchaseNumber",
        "purchaseOrderNumber",
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "PurchaseReceipt#",
        "purchaseOrderReceiptNumber",
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("ReceiptDate", "receivedDate"),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Color",
        "fabricStyleColorCode",
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "VendorLot#",
        "vendorBatchNumber",
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Roll#", "rollNumber"),
    );
    if (this.state.is3PL) {
      columnList.push(
        new DataGridColumnDefinition().setDetails("Item", "fabricStyleCode"),
      );
    } else {
      columnList.push(
        new DataGridColumnDefinition().setDetails(
          "FabricStyle",
          "fabricStyleCode",
        ),
      );
    }
    columnList.push(
      new DataGridColumnDefinition().setDetails("Name", "fabricStyleName"),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("WidthCode", "widthCode"),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Location", "locationCode"),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "RcvdQty",
        "receivedQuantity",
        1,
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "OnHandQty#",
        "onHandQuantity",
        1,
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("UOM", "uomCode"),
    );

    return columnList;
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  clearCriteria = () => {
    let tempCriteria = new SKUBatchInventorySearchCriteria();
    tempCriteria.companyCode = this.companyCode;
    let roll_criteria = new SKUBatchInventoryPrintInputCriteria();
    roll_criteria.noOfCopies = 1;
    this.setState({
      criteria: tempCriteria,
      roll_criteria: roll_criteria,
      isShowColorLookup: false,
      colorList: [],
    });
    this.hideAlertCallBack();
  };
  resetView = () => {
    let criteria = new SKUBatchInventorySearchCriteria();
    criteria.companyCode = this.companyCode;
    let roll_criteria = new SKUBatchInventoryPrintInputCriteria();
    roll_criteria.noOfCopies = 1;
    this.setState({
      criteria: criteria,
      roll_criteria: roll_criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowLookup: true,
      isShowColorLookup: false,
      fabricStyleData: new Array(),
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isDisabledFields: false,
      colorList: [],
      selectedRollSkuList: [],
    });
    this.hideAlertCallBack();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };


    loadPrevious = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.max(
          parseInt(prevState.currentPage) - 1,
          1,
        );
        return { currentPage: newPage };
      },
      () => {
        this.loadPage();
      },
    );
  };

  //   loadNext = () => {
  //   this.setState(
  //     (prevState) => {
  //       const newPage = Math.min(
  //         parseInt(prevState.currentPage) + 1,
  //         prevState.currentPage,
  //       );
  //       return { currentPage: newPage };
  //     },
  //     () => {

        
  //       this.loadPage();
  //     },
  //   );
  // };

  loadNext = () => {
  this.setState(
    (prevState) => ({
      currentPage: Math.min(
        parseInt(prevState.currentPage, 10) + 1,
        prevState.totalPage
      ),
    }),
    () => {

      this.loadPage();
    }
  );
};

    loadFirst = () => {
    this.setState({ currentPage: 1 }, () => {
      this.loadPage();
    });
  };

  loadLast = () => {
    this.setState(
      { currentPage: this.state.totalPage},
      () => {
        this.loadPage();
      },
    );
  };
    onPageClick = (e) => {
    let currentPage = e;
    this.setState(
      {
        currentPage: currentPage,
      },
      () => {
        this.loadPage();
      },
    );
  };
  pageOnChange = (e) => {
    let currentPage = this.state.currentPage;
    currentPage = e.target.value;
    this.setState({
      currentPage: currentPage,
    });
  };

    pageOnBlur = (e) => {
    this.setState(
      (prevState) => {
        let newPage = parseInt(e.target.value, 10);

        if (isNaN(newPage) || newPage < 1) {
          newPage = 1; // Default to page 1 if invalid
        } else if (newPage > prevState.totalPage) {
          newPage = prevState.totalPage; // Cap at total pages
        }

        return { currentPage: newPage };
      },
      () => {
        this.loadPage();
      },
    );
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let currentPage  =  this.state.currentPage;
    let totalPage  =  this.state.totalPage;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowExitButton={this.state.isShowExitButton}
          isShowResetButton={this.state.isShowResetButton}
          execute={this.execute}
          reset={this.resetView}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          onModuleExit={this.moduleExit}
        />
        <CriteriaView
          {...this.state}
          onChange={this.onChange}
          rollOnChange={this.rollOnChange}
          fabricCodeOnChange={this.fabricCodeOnChange}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
          fabricColourEnterKeyEventHandler={
            this.fabricColourEnterKeyEventHandler
          }
          displayAutoCompleteFabricColorList={
            this.displayAutoCompleteFabricColorList
          }
          onFabricColourCodeChange={this.onFabricColourCodeChange}
          onLocationChange={this.onLocationChange}
          locationEnterKeyEventHandler={this.locationEnterKeyEventHandler}
          displayAutoCompleteLocationList={this.displayAutoCompleteLocationList}
          onPurchaseOrderChange={this.onPurchaseOrderChange}
          purchaseOrderEnterKeyEventHandler={
            this.purchaseOrderEnterKeyEventHandler
          }
          displayAutoCompletePurchaseOrderList={
            this.displayAutoCompletePurchaseOrderList
          }
          adjustmentOnChange={this.adjustmentOnChange}
          adjustmentEnterKeyEventHandler={this.adjustmentEnterKeyEventHandler}
          displayAutoCompleteAdjustmentList={
            this.displayAutoCompleteAdjustmentList
          }
          onPurchaseReceiptChange={this.onPurchaseReceiptChange}
          purchaseReceiptEnterKeyEventHandler={
            this.purchaseReceiptEnterKeyEventHandler
          }
          displayAutoCompletepurchaseReceiptList={
            this.displayAutoCompletepurchaseReceiptList
          }
        />
        {this.state.isInquiryDatasFound &&
          !isEmptyArray(this.state.inquiryDataList) && (
            <Row>
              <Col sm="1">
                <Button
                  id="fabric_Add_Button"
                  size="sm"
                  onClick={(e) => this.lineSelectAll(e)}
                >
                  SelectAll
                </Button>
              </Col>
              <Col sm="1">
                <Button
                  id="fabric_Add_Button"
                  size="sm"
                  onClick={(e) => this.lineUnSelectAll(e)}
                >
                  UnSelectAll
                </Button>{" "}
              </Col>
              <Col sm="1">
                {" "}
                <Button
                  id="fabric_Add_Button"
                  size="sm"
                  onClick={(e) => this.generatePDF(e)}
                >
                  MultiPrint
                </Button>{" "}
              </Col>
              <Col sm="1">
                {" "}
                <Button
                  id="fabric_Add_Button"
                  size="sm"
                  onClick={(e) => this.colorLotList(e)}
                >
                  Color/lot
                </Button>{" "}
              </Col>
            </Row>
          )}
        {this.state.isInquiryDatasFound && (
          <div className="mt-3">
            <CustomTable
              data={inquiryDataList}
              columns={this.columnDefinitions()}
                   isShowPagination={true}
                       loadPrevious={(e) => this.loadPrevious(e)}
                      loadNext={(e) => this.loadNext(e)}
                      currentPage={currentPage}
                      totalPages={totalPage}
                      handleOnchange={(e) => this.pageOnChange(e)}
                      handlePaginationOnBlur={(e) =>
                        this.pageOnBlur(e)
                      }
                      onPageClick={(e) => this.onPageClick(e)}
                      isShowRowPerPage = {false}
            />
            {/* <EditableDataGrid
              columnsList={this.columnDefinitions()}
              dataList={inquiryDataList}
            /> */}
          </div>
        )}
      </div>
    );
  }
}
export function CriteriaView(props) {
  const onChange = (e) => props.onChange(e);
  const rollOnChange = (e) => props.rollOnChange(e);
  const fabricCodeOnChange = (e) => {
    props.fabricCodeOnChange(e);
  };
  const onFabricColourCodeChange = (e) => {
    props.onFabricColourCodeChange(e);
  };
  const fabricEnterKeyEventHandler = (e) => {
    props.fabricEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricList = () => {
    props.displayAutoCompleteFabricList();
  };

  const fabricColourEnterKeyEventHandler = (e) => {
    props.fabricColourEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricColorList = () => {
    props.displayAutoCompleteFabricColorList();
  };
  const locationEnterKeyEventHandler = (e) => {
    props.locationEnterKeyEventHandler(e);
  };
  const displayAutoCompleteLocationList = () => {
    props.displayAutoCompleteLocationList();
  };

  const onLocationChange = (e) => {
    props.onLocationChange(e);
  };
  const purchaseOrderEnterKeyEventHandler = (e) => {
    props.purchaseOrderEnterKeyEventHandler(e);
  };
  const displayAutoCompletePurchaseOrderList = () => {
    props.displayAutoCompletePurchaseOrderList();
  };

  const onPurchaseOrderChange = (e) => {
    props.onPurchaseOrderChange(e);
  };
  const purchaseReceiptEnterKeyEventHandler = (e) => {
    props.purchaseReceiptEnterKeyEventHandler(e);
  };
  const displayAutoCompletepurchaseReceiptList = () => {
    props.displayAutoCompletepurchaseReceiptList();
  };

  const onPurchaseReceiptChange = (e) => {
    props.onPurchaseReceiptChange(e);
  };
  const adjustmentEnterKeyEventHandler = (e) => {
    props.adjustmentEnterKeyEventHandler(e);
  };
  const displayAutoCompleteAdjustmentList = () => {
    props.displayAutoCompleteAdjustmentList();
  };

  const adjustmentOnChange = (e) => {
    props.adjustmentOnChange(e);
  };
  let criteria = props.criteria;
  let roll_criteria = props.roll_criteria;
  let fabricCodeRef = React.createRef();
  let colorCodeRef = React.createRef();
  let purchaseCodeRef = React.createRef();
  let receiptCodeRef = React.createRef();
  let adjustmentCodeRef = React.createRef();
  let locationCodeRef = React.createRef();
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          {" "}
          <FormLabel>CompanyCode</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            name="companyCode"
            onChange={onChange}
            value={criteria.companyCode}
            readOnly={true}
          />
        </Col>

        <Col sm="1">
          {" "}
          <FormLabel>PurchaseOrder</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={purchaseCodeRef}
            onChange={onPurchaseOrderChange}
            disabled={props.isDisabledFields}
            name="purchaseOrderNumber"
            placeholder="purchaseOrderNumber"
            value={criteria.purchaseOrderNumber}
            lookupRequired={props.isShowLookup}
            lookupHandler={props.purchaseOrderLookupHandler}
            enterKeyEventHandler={purchaseOrderEnterKeyEventHandler}
            autoCompleteListData={
              props.purchaseOrderPageListForAutoCompleteList
            }
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompletePurchaseOrderList}
            showAutoCompleteList={props.isShowAutoCompletePurchaseOrderList}
            isMandatory={true}
          />
        </Col>

        <Col sm="1">
          <FormLabel>Purchase Receipt</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            onChange={onPurchaseReceiptChange}
            ref={receiptCodeRef}
            name="purchaseReceitpNumber"
            placeholder="purchaseReceitpNumber"
            value={criteria.purchaseReceitpNumber}
            lookupRequired={props.isShowLookup}
            lookupHandler={props.purchaseReceiptLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={purchaseReceiptEnterKeyEventHandler}
            autoCompleteListData={
              props.purchaseReceiptPageListForAutoCompleteList
            }
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompletepurchaseReceiptList}
            showAutoCompleteList={props.showAutoCompletepurchaseReceiptList}
            disabled={props.isDisabledFields}
            isMandatory={true}
          />
        </Col>

        <Col sm="1">
          <FormLabel>InvAdjustment Number</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            onChange={adjustmentOnChange}
            ref={adjustmentCodeRef}
            name="inventoryAdjustmentNumber"
            placeholder="inventoryAdjustmentNumber"
            value={criteria.inventoryAdjustmentNumber}
            lookupRequired={props.isShowLookup}
            lookupHandler={props.inventoryAdjustmentLookupHandler}
            enterKeyEventHandler={adjustmentEnterKeyEventHandler}
            autoCompleteListData={props.adjustmentPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteAdjustmentList}
            showAutoCompleteList={props.isShowAutoCompleteAdjustmentList}
            disabled={props.isDisabledFields}
            isMandatory={true}
          ></InputTextbox>
        </Col>
      </Row>
      <Row>
        <Col sm="1">
          {props.is3PL ? (
            <FormLabel>Item</FormLabel>
          ) : (
            <FormLabel>FabricStyle</FormLabel>
          )}
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={fabricCodeRef}
            name="fabricStyleCode"
            onChange={fabricCodeOnChange}
            value={criteria.fabricStyleCode}
            lookupRequired={props.isShowLookup}
            lookupHandler={props.fabricLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={fabricEnterKeyEventHandler}
            autoCompleteListData={props.fabricPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricList}
            showAutoCompleteList={props.showAutoCompleteFabricList}
            disabled={props.isDisabledFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="1">
          {" "}
          <FormLabel>Color</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={colorCodeRef}
            name="colorCode"
            onChange={onFabricColourCodeChange}
            value={criteria.colorCode}
            lookupRequired={props.isShowColorLookup}
            lookupHandler={props.colorLookupHandler}
            enterKeyEventHandler={fabricColourEnterKeyEventHandler}
            autoCompleteListData={props.fabricColourPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricColorList}
            showAutoCompleteList={props.showAutoCompleteFabricColorList}
            disabled={!props.isShowColorLookup}
          />
        </Col>

        <Col sm="1">
          {" "}
          <FormLabel>Location</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            name="locationCode"
            value={criteria.locationCode}
            lookupRequired={props.isShowLookup}
            lookupHandler={props.warehouseLookupHandler}
            onChange={onLocationChange}
            ref={locationCodeRef}
            enterKeyEventHandler={locationEnterKeyEventHandler}
            autoCompleteListData={props.locationPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteLocationList}
            showAutoCompleteList={props.showAutoCompleteLocationList}
            disabled={props.isDisabledFields}
          />
        </Col>

        <Col sm="1">
          {" "}
          <FormLabel>NumberOf Copies</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            onChange={rollOnChange}
            name="noOfCopies"
            value={roll_criteria.noOfCopies}
          />
        </Col>
      </Row>
      <Row>

         <Col sm="1">
          {" "}
          <FormLabel>RollSKU#</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            onChange={onChange}
            name="rollSkuNumber"
            value={criteria.rollSkuNumber}
              disabled={props.isDisabledFields}
          />
        </Col>

         <Col sm="1">
          {" "}
          <FormLabel>Lot#</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            onChange={onChange}
            name="vendorBatchNumber"
            value={criteria.vendorBatchNumber}
              disabled={props.isDisabledFields}
          />
        </Col>

      </Row>
    </div>
  );
}
function PrintRollModule(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div className="App">
        <PrintRollForm {...props} name="" /> <br />
      </div>
    </div>
  );
}

export default PrintRollModule;
